export enum Lang {
	None,
	En,
	Ru,
	De,
	Es,
	Fr, 
	It
}